import FormSection from '@Guidelines/Component/FormSection';
import type AiModelFormData from '@UI/Pages/Administration/AiEngines/Sidebars/ModelSidebar/FormData/AiModelFormData';
import { Checkbox, InputText, TextArea } from '@verclam/ui-kit';
import * as React from 'react';

type Props = {
	formData: AiModelFormData;
	setFormData: React.Dispatch<React.SetStateAction<AiModelFormData>>;
};

const AzureSpeechSettingsSection: React.FC<Props> = ({ formData, setFormData }) => {
	const handleLocaleChange = React.useCallback(
		(value: string) => {
			setFormData((current) => current.setSpeechLocale(value));
		},
		[setFormData],
	);

	const handleMaxSpeakersChange = React.useCallback(
		(value: string) => {
			setFormData((current) => current.setSpeechMaxSpeakers(value));
		},
		[setFormData],
	);

	const handleProfanityFilterChange = React.useCallback(
		(value: boolean) => {
			setFormData((current) => current.setSpeechProfanityFilter(value));
		},
		[setFormData],
	);

	const handlePhrasesChange = React.useCallback(
		(value: string) => {
			setFormData((current) => current.setSpeechPhrases(value));
		},
		[setFormData],
	);

	const handlePhraseWeightChange = React.useCallback(
		(value: string) => {
			setFormData((current) => current.setSpeechPhraseWeight(value));
		},
		[setFormData],
	);

	return (
		<FormSection title="Réglages Microsoft">
			<InputText
				name="speechLocale"
				label="Langue"
				value={formData.speechLocale}
				onChange={handleLocaleChange}
				errorMessage={formData.getValidationMessage('speechLocale')}
				isFormFieldValid={formData.isValid('speechLocale')}
			/>
			<InputText
				name="speechMaxSpeakers"
				label="Nombre maximal de locuteurs"
				subLabel="Appliqué quand l’usage demande la séparation des locuteurs."
				value={formData.speechMaxSpeakers}
				onChange={handleMaxSpeakersChange}
				errorMessage={formData.getValidationMessage('speechMaxSpeakers')}
				isFormFieldValid={formData.isValid('speechMaxSpeakers')}
			/>
			<Checkbox
				name="speechProfanityFilter"
				label="Masquer les grossièretés"
				checked={formData.speechProfanityFilter}
				onChange={handleProfanityFilterChange}
				errorMessage={formData.getValidationMessage('speechProfanityFilter')}
				isFormFieldValid={formData.isValid('speechProfanityFilter')}
			/>
			<TextArea
				name="speechPhrases"
				label="Vocabulaire métier"
				subLabel="Une expression par ligne, 2000 au plus."
				rows={6}
				value={formData.speechPhrases}
				onChange={handlePhrasesChange}
				errorMessage={formData.getValidationMessage('speechPhrases')}
				isFormFieldValid={formData.isValid('speechPhrases')}
			/>
			<InputText
				name="speechPhraseWeight"
				label="Poids du vocabulaire"
				subLabel="De 0 à 2. Laissez vide pour le poids de Microsoft."
				value={formData.speechPhraseWeight}
				onChange={handlePhraseWeightChange}
				errorMessage={formData.getValidationMessage('speechPhraseWeight')}
				isFormFieldValid={formData.isValid('speechPhraseWeight')}
			/>
		</FormSection>
	);
};

export default AzureSpeechSettingsSection;
